import axios from '@/api/axios'

export default {
    /* 求职用户登录 */

    talentLogin: (params) => axios.post('/c/user/saas/user/login', params),

    /* 获取验证码 (无权限) */

    getValidateCodeNotAuth: (params) => axios.post('/c/base/v1/sms/captcha/send', params),

    /* 获取验证码 (有权限) */

    getValidateCodeAuth: (params) => axios.post('/c/base/v1/sms/captcha/send:auth', params),

    /* 获取用户信息  */
    getProfile: (params) => axios.post('/c/user/v1/user/profile', params),

    /* 修改密码 */
    changePassword: (params) => axios.post('/c/user/v1/profile/changePassword', params),

    /* 获取用户信息  (简历)*/
    getProfileForResume: (params) => axios.post('/c/resume/saas/resume/detail', params),

    //接受邀请
    getInvitation: (params) => axios.get('/c/company/saas/job/invitation/accept', params),

    //公司详情
    companyDetail: (params) => axios.get('/c/company/saas/company/detail', params),

    getJobDetail: (params) => axios.get(`/c/company/saas/job/detail`, { params }),

    getJobDetailNoAuth: (params) => axios.get(`/c/company/saas/job/detail/noAuth`, { params }),

    //获取面试信息
    getInterview: (params) => axios.get(`/c/interview/v1/interview/detail`, { params }),

    //初始化面试
    initInterview: (data) => axios.post(`/c/interview/saas/ai/init/v2`, data),

    //获取画像
    getportrait: (params) => axios.get(`/c/interview/v1/ai/get/portrait`, params),

    //提交面试结果
    saveRecord: (data) => axios.post(`/c/interview/v1/ai/save/record`, data),

    //获取语音
    getTts: (data) => axios.post(`/c/goai/v1/tts`, data),

    //获取sts
    getKey: (params) => axios.get(`/c/base/v1/oss/sts`, params),

    //获取校验token
    getStsKey: () => axios.get(`/c/base/v1/stt/sts`),
    //上传解析简历
    getResumeParse: (params) => axios.post('/c/resume/saas/resume/parse', params),
    //同步更新简历
    getResumeUpdate: (params) => axios.post('/c/resume/saas/resume/update', params),
    // 保存简历基本信息
    saveResumeBasicInfo: (params) => axios.post('/c/resume/saas/basicInfo/save', params),
    // 简历更新求职状态
    workStatusSave: (params) => axios.post('/c/resume/saas/workStatus/save', params),
    // 添加修改优势亮点
    highlightSave: (params) => axios.post('/c/resume/saas/highlight/save', params),
    // 创建修改求职期望
    jobExpectationSave: (params) => axios.post('/c/resume/saas/jobExpectation/save', params),
    // 删除求职期望
    jobExpectationDelete: (params) => axios.post('/c/resume/saas/jobExpectation/delete', params),
    // 创建/修改教育经历
    getEduExpSave: (params) => axios.post('/c/resume/saas/eduExp/save', params),
    // 删除教育经历
    getEduExpDelete: (data) => axios.post('/c/resume/saas/eduExp/delete', data),
    // 创建/更新工作经历
    getWorkExpSave: (data) => axios.post('/c/resume/saas/workExp/save', data),
    // 删除工作经历
    getWorkExpDelete: (data) => axios.post('/c/resume/saas/workExp/delete', data),
    // 创建/更改项目经历
    getProjectExpSave: (data) => axios.post('/c/resume/saas/projectExp/save', data),
    // 删除项目经历
    getProjectExpDelete: (data) => axios.post('/c/resume/saas/projectExp/delete', data),
    // 面试列表
    getAgentMatchRecord: (params) => axios.get('/c/interview/saas/agentMatchRecord/list', { params }),
    // 校验
    getInvitationCheck: (params) => axios.get('/c/company/saas/job/invitation/check', { params }),

    // im 保存发送信息 没有登录
    saveMessageToTalentNoAuth: (data) => axios.post('/c/interview/saas/chat/im/noAuth', data),
    //获取地址
    openWechat: (data) => axios.post('/c/user/saas/user/wechatScheme', data),

    // 面试邀请函列表
    getInvitationLetter: (params) => axios.get('/c/company/saas/job/interview/invitation', { params }),

    // 获取C端客服im 账号
    getImUserSigC: (params) => axios.get('/c/base/v1/customerServer/get', { params }),
    // 保存im聊天信息
    saveChatImToC: (params) => axios.post('/c/interview/saas/chat/im', params),
    //面试锁
    interviewKey: (data) => axios.post('/c/interview/v1/reset_interview_time', data),
    //检查面试
    is_interview: (data) => axios.post('/c/interview/v1/is_interview', data),
    //保存面试log
    saveInterviewLog: (data) => axios.post('/c/interview/v1/ai/interview/record/detail', data),

    getDictC: (params) => axios.get(`/c/base/v1/dict/data/getDictData`, { params }),

    /* 获取行业 */
    getIndustry: (params) => axios.get('/c/base/v1/industry', { params }),

    /* 获取省市城市 */
    getProvinceCity: (params) => axios.get('/c/base/v1/provinceCity', { params }),

    // 取消面试
    cancelInterview: (params) => axios.post('/c/company/saas/job/cancel', params),
    // 实名认证
    idCardVerify: (params) => axios.post('/c/user/v1/profile/idCardVerify', params),

    // 获取职位列表（活动）
    getPositionForActivity: (params) => axios.post('/c/company/saas/job/saasSearch', params),

    // 获取小程序url（拉起）
    getWXminiUrl: (params) => axios.get('/c/base/v1/miniprogram/link', { params }),
    /* B端新手引导状态修改*/
    newbieGuideUpdateC: (params) => axios.post('/c/user/v1/welcome/set', params),
    /* 获取B端新手引导状态 */
    getnewbieGuideTypeC: (params) => axios.post('/c/user/v1/welcome/status', params),
    /* 获取面试报告 */
    getAiReport: (params) => axios.get('/c/interview/v1/aiReport/v2', { params }),
    /* 获取面试报告2 */
    getAiReports: (params) => axios.get('/c/interview/v1/aiReport/full/v2', { params }),
    /* 检查权限点剩余次数 */
    getCheckRights: (params) => axios.get('/c/order/v1/order/count', { params }),
    // 获取C端菜单列表
    getMenus: () => axios.get('/c/order/v1/menus'),
    // 创建快速支付订单
    createFastOrder: (params) => axios.post('/c/order/v1/order/fast', params),
    // 获取C断微信支付二维码
    getWechatQrcode: (params) => {
        const { order_no } = params
        return axios.post(`/c/order/v1/order/${order_no}/wechat/qr`)
    },
    // 获取C端支付宝支付二维码
    payCallback: (params) => {
        const { order_no } = params
        return axios.post(`/c/order/v1/order/${order_no}/alipay/qr`)
    },
    // 订单权益点是否扣除检查
    buyOrderReport: (params) => axios.post('/c/order/v1/buy/report', params),
    // 订单详情
    getOrderDetail: (params) => {
        const { order_no } = params;
        return axios.get(`/c/order/v1/order/${order_no}/detail`);
    },
    // 订单列表
    getOrders: params => axios.get('/c/order/v1/orders', { params }),

    // 创建C端支付订单
    createOrder: (params) => axios.post(`/c/order/v1/order`, params),

    // 删除订单
    deleteOrder: (params) => {
        const { order_no } = params;
        return axios.post(`/c/order/v1/order/${order_no}/delete`);
    },
    // C段权益点使用明细
    getRightsUsedDetails: (params) => axios.get('/c/order/saas/rights/used/details', { params }),
    // 获取热门城市列表
    getHotCitiesList: () => axios.get('/c/base/v1/city'),
    // 模拟职位列表
    getVirtualPositionList: (params) => axios.post('/c/interview/v1/virtual/position/list', params),
    // 职业福利
    getSocialBenefits: () => axios.get('/c/base/v1/tag/list?tag_type=1'),

    // 生成虚拟职位
    generateVnPosition: (params, option) => axios.post('/c/interview/v1/virtual/position/create', params, {
        cancelToken: option.cancelToken
    }),

    getVnPosition: params => axios.get('/c/interview/v1/virtual/position/detail', { params }),
    // 普通简历优化
    resumeOptimizeBasic: (params, option) => axios.post('/c/interview/v1/resumeOptimize/basic', params, {
        cancelToken: option.cancelToken
    }),


    // 职业辅导 ai对话

    // 对话聊天
    createDialogueChat: (params, onChunk) => {
        let lastProcessedLength = 0; // 记录上一次处理到的位置
        return axios({
            method: 'post',
            url: '/c/goai/v1/dialog/chat',
            data: params,
            responseType: 'stream',
            onDownloadProgress: (progressEvent) => {
                const target = progressEvent.event.target;
                const response = target.response;
                if (!response) return;

                // 1. 将响应数据转为字符串（处理 ArrayBuffer 或字符串类型）
                let fullText;
                if (response instanceof ArrayBuffer) {
                    fullText = new TextDecoder('utf-8').decode(response);
                } else if (typeof response === 'string') {
                    fullText = response;
                } else {
                    console.warn('未知的响应类型:', response);
                    return;
                }

                // 2. 提取「本次新增的片段」（从上次处理的位置到结尾）
                const newChunk = fullText.slice(lastProcessedLength);
                if (!newChunk) return; // 没有新增内容，直接返回

                // 3. 更新已处理长度（下次从这里开始）
                lastProcessedLength = fullText.length;

                // 4. 解析新增片段（和之前逻辑一致，但只处理新内容）
                function processChunk(textChunk) {
                    const lines = textChunk.split('\n');
                    lines.forEach(line => {
                        const trimmedLine = line.trim();
                        if (!trimmedLine) return;
                        const jsonStr = trimmedLine.replace(/^data: /, '');
                        if (!jsonStr) return;
                        try {
                            const data = JSON.parse(jsonStr);
                            if (data.type === 'chunk') {
                                onChunk(data.content); // 只触发新增内容的回调
                            }
                        } catch (e) {
                            console.error('解析失败:', e);
                        }
                    });
                }
                processChunk(newChunk);
            }
        });
    },
    // 删除对话
    deleteDialogueChat: params => axios.post('/c/goai/v1/dialog/del', params),
    // 对话历史
    getDialogueChatHistory: params => axios.get('/c/goai/v1/dialog/history', { params }),
    // 对话列表
    getDialogueChatList: params => axios.get('/c/goai/v1/dialog/list', { params }),

    // 模拟面试初始化
    mockInterviewInit: params => axios.post('/c/interview/v1/virtual/interview/init', params),
    // 模拟面试提交回答
    mockInterviewSubmit: params => axios.post('/c/interview/v1/virtual/interview/submit', params),
    // 模拟面试提交回答相关文件
    mockInterviewSubmitFile: params => axios.post('/c/interview/v1/virtual/interview/submitFile', params),
    // 模拟面试结束
    mockInterviewOver: params => axios.post('/c/interview/v1/virtual/interview/finish', params),
    // 模拟面试报告
    getMockInterviewReport: params => axios.get('/c/interview/v1/virtual/interview/report', { params }),
    // 模拟面试列表
    getMockInterviewList: params => axios.post('/c/interview/v1/virtual/interview/list', params),

    // 深度优化聊天 - 支持流式响应
    deepOptimizeChat: (params, onChunk) => {
        let lastProcessedLength = 0; // 记录上一次处理到的位置
        return axios({
            method: 'post',
            url: '/resume/deep-optimization/converse',
            data: params,
            responseType: 'stream',
            onDownloadProgress: (progressEvent) => {
                const target = progressEvent.event.target;
                const response = target.response;
                if (!response) return;

                // 1. 将响应数据转为字符串（处理 ArrayBuffer 或字符串类型）
                let fullText;
                if (response instanceof ArrayBuffer) {
                    fullText = new TextDecoder('utf-8').decode(response);
                } else if (typeof response === 'string') {
                    fullText = response;
                } else {
                    console.warn('未知的响应类型:', response);
                    return;
                }

                // 2. 提取「本次新增的片段」（从上次处理的位置到结尾）
                const newChunk = fullText.slice(lastProcessedLength);
                if (!newChunk) return; // 没有新增内容，直接返回

                // 3. 更新已处理长度（下次从这里开始）
                lastProcessedLength = fullText.length;

                // 4. 解析新增片段
                function processChunk(textChunk) {
                    const lines = textChunk.split('\n');
                    lines.forEach(line => {
                        const trimmedLine = line.trim();
                        if (!trimmedLine) return;

                        // 处理流式数据格式
                        let jsonStr = trimmedLine;
                        if (trimmedLine.startsWith('data: ')) {
                            jsonStr = trimmedLine.replace(/^data: /, '');
                        }

                        if (!jsonStr) return;

                        try {
                            const data = JSON.parse(jsonStr);
                            if (onChunk) {
                                onChunk(data);
                            }
                        } catch (e) {
                            console.error('解析失败:', e, '原始数据:', jsonStr);
                        }
                    });
                }
                processChunk(newChunk);
            }
        });
    },

    // 面试仓赠送1000权益点 （黄石专属）
    obtainGiftBenefits: (params) => axios.get('/c/order/saas/yellowStone/capsuleGift', { params }),

    // 简历深度优化初始化
    resumeDeepOptInit: (params, option) => axios.post('/c/interview/v1/resume/deepOptimize/init', params, {
        cancelToken: option.cancelToken
    }),

    // 简历深度优化提交
    resumeDeepOptSubmit: params => axios.post('/c/interview/v1/resume/deepOptimize/submit', params),

    // 简历深度优化结束
    resumeDeepFinish: params => axios.post('/c/interview/v1/resume/deepOptimize/finish', params),

    // 推荐职位
    recommendPosition: params => axios.get('/c/interview/v1/virtual/position/recommend', { params })
}